import { Injectable, inject } from '@angular/core';
import { AppActions } from '@navfleet/client/core/app';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ReferenceDataCountryListApi } from '../api/reference-data-countries.api';
import * as CountriesDataActions from './reference-data-countries.actions';
import * as fromCountriesData from './reference-data-countries.reducer';
import * as CountryDataSelectors from './reference-data-countries.selectors';

@Injectable()
export class ReferenceDataCountriesEffects {
    private readonly actions$ = inject(Actions);
    private readonly countryListApi = inject(ReferenceDataCountryListApi);
    private readonly store$ = inject<Store<fromCountriesData.State>>(Store);

    public readonly initCountryListLoad$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.loadAppData),
            withLatestFrom(this.store$.pipe(select(CountryDataSelectors.countryList))),
            filter(([, countryList]) => !!countryList && !countryList.length),
            map(() => CountriesDataActions.countryListLoad())
        )
    );

    public readonly countryListLoad$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CountriesDataActions.countryListLoad),
            switchMap(() => this.countryListApi.getCountryList()),

            map((countryList) =>
                CountriesDataActions.countryListLoadSuccess({
                    countryList,
                })
            ),
            catchError((error) => of(CountriesDataActions.countryListLoadFailed({ error })))
        )
    );
}
